import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Card } from './ui/card';
import { Button } from './ui/button';
import { ChevronRight } from 'lucide-react';

export const JuryCarousel = () => {
  const [offset, setOffset] = useState(0);

  const juryMembers = [
    {
      name: 'Sarah Mitchell',
      title: 'Creative Director',
      organization: 'Global Exhibitions Ltd',
      image: 'https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?w=400&h=500&fit=crop'
    },
    {
      name: 'Dr. Marcus Chen',
      title: 'Professor of Design',
      organization: 'Royal College of Art',
      image: 'https://images.unsplash.com/photo-1556157382-97eda2d62296?w=400&h=500&fit=crop'
    },
    {
      name: 'Maria Rodriguez',
      title: 'Chief Experience Officer',
      organization: 'Innovative Spaces Inc',
      image: 'https://images.unsplash.com/photo-1580489944761-15a19d654956?w=400&h=500&fit=crop'
    },
    {
      name: 'James Chen',
      title: 'Head of Design',
      organization: 'European Trade Shows',
      image: 'https://images.unsplash.com/photo-1519085360753-af0119f7cbe7?w=400&h=500&fit=crop'
    },
    {
      name: 'Lisa Anderson',
      title: 'Brand Strategist',
      organization: 'Momentum Agency',
      image: 'https://images.unsplash.com/photo-1544005313-94ddf0286df2?w=400&h=500&fit=crop'
    },
    {
      name: 'Michael Roberts',
      title: 'Senior Designer',
      organization: 'Studio Norte',
      image: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=400&h=500&fit=crop'
    },
    {
      name: 'Emily Watson',
      title: 'Vice President',
      organization: 'Design Collective',
      image: 'https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=400&h=500&fit=crop'
    },
    {
      name: 'David Kim',
      title: 'Innovative Director',
      organization: 'Innovate Designs',
      image: 'https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=400&h=500&fit=crop'
    },
    {
      name: 'Sophie Laurent',
      title: 'Brand Designer',
      organization: 'Nordic Designs',
      image: 'https://images.unsplash.com/photo-1487412720507-e7ab37603c6f?w=400&h=500&fit=crop'
    },
    {
      name: 'Robert Johnson',
      title: 'Experience Lead',
      organization: 'Global Events',
      image: 'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=400&h=500&fit=crop'
    }
  ];

  // Auto-scroll animation
  useEffect(() => {
    const interval = setInterval(() => {
      setOffset((prev) => {
        const newOffset = prev - 1;
        // Reset when scrolled through all items
        if (Math.abs(newOffset) >= (juryMembers.length * 320)) {
          return 0;
        }
        return newOffset;
      });
    }, 30); // Adjust speed here (lower = faster)

    return () => clearInterval(interval);
  }, [juryMembers.length]);

  // Double the array for seamless loop
  const displayMembers = [...juryMembers, ...juryMembers];

  return (
    <section className="py-20 bg-white overflow-hidden" data-testid="jury-carousel-section">
      <div className="w-full max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 mb-12">
        <div className="text-center">
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-extrabold text-gray-900 mb-4">
            Meet Our Jury
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto mb-8">
            20 distinguished professionals from around the globe evaluating every submission with expertise and impartiality
          </p>
        </div>
      </div>

      {/* Carousel Container */}
      <div className="relative">
        <div className="overflow-hidden">
          <div
            className="flex gap-4 transition-transform"
            style={{
              transform: `translateX(${offset}px)`,
              willChange: 'transform'
            }}
          >
            {displayMembers.map((member, index) => (
              <Card
                key={`${member.name}-${index}`}
                className="flex-shrink-0 w-[240px] bg-white border shadow-sm hover:shadow-md transition-shadow"
                data-testid={`jury-carousel-card-${index}`}
              >
                <div className="aspect-[3/4] overflow-hidden rounded-t-xl">
                  <img
                    src={member.image}
                    alt={member.name}
                    className="w-full h-full object-cover"
                  />
                </div>
                <div className="p-3 text-center">
                  <h3 className="text-base font-bold text-gray-900 mb-1">
                    {member.name}
                  </h3>
                  <p className="text-xs font-semibold text-amber-600 mb-1">
                    {member.title}
                  </p>
                  <p className="text-xs text-gray-600">
                    {member.organization}
                  </p>
                </div>
              </Card>
            ))}
          </div>
        </div>
      </div>

      {/* View All Button */}
      <div className="w-full max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 mt-12 text-center">
        <Link to="/jury">
          <Button
            className="inline-flex items-center gap-2 bg-black hover:bg-gray-900 text-white font-semibold px-8 py-3 rounded-full transition-colors duration-200"
            data-testid="view-all-jury-button"
          >
            View All Jury Members
            <ChevronRight className="h-4 w-4" />
          </Button>
        </Link>
      </div>
    </section>
  );
};
